import React from "react";

const PriceBox = ({
  item,
  productDetail = false,
  showWebPriceTitle = true,
}) => {
  const formattedPrice = (price) => {
    if (price == null || price === "") return "0,00";

    // Pretvori u broj
    const number = Number(price);

    // Formatiraj sa hiljadarkama i dve decimale
    return number
      .toFixed(2) // obavezno dve decimale
      .replace(".", ",") // decimalna tačka → zarez
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // hiljadarke tačka
  };

  return (
    <div>
      {item?.fixPrice > 0 ? (
        <>
          {item?.fixPrice < item?.cashPrice && (
            <div className="old-price-custom-div">
              <del>{formattedPrice(item?.cashPrice)} RSD</del>
            </div>
          )}

          <ins class="new-price new-price-custom">
            {formattedPrice(item?.fixPrice)} <small>RSD</small>
          </ins>
        </>
      ) : (
        <>
          <ins class="new-price new-price-custom">
            {/* <div className="new-price-custom-title">Web cena:</div> */}
            {showWebPriceTitle && <span>Web cena:</span>}{" "}
            {formattedPrice(item?.cashPrice)} <small>RSD</small>
          </ins>
          {item?.price > 1000 && (
            <div class="payment-price-custom">
              MP cena: {formattedPrice(item?.price)} <small>RSD</small>
            </div>
          )}
          {productDetail &&
            item?.price - item?.cashPrice > 0 &&
            item?.price > 1000 && (
              <div className="info-price-box-custom">
                Ušteda: {formattedPrice(item?.price - item?.cashPrice)}{" "}
                <small>RSD</small>
              </div>
            )}
        </>
      )}
    </div>
  );
};

export default PriceBox;
